'use client';

import { useState } from 'react';

import { generateMatchTitle } from '@/modules/players/v2/tabs/videos/videoUtils';
import { PlayerVideosData } from '@/types/players.types';

interface YoutubeCardsProps {
  youtubeVideoId: string;
  start?: number;
  video: PlayerVideosData;
}

export const YoutubeCards = ({ youtubeVideoId, start, video }: YoutubeCardsProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const params = start ? `rel=0&start=${start}` : 'rel=0';
  const thumbnailUrl = `https://i.ytimg.com/vi/${youtubeVideoId}/hqdefault.jpg`;

  return (
    <div className='rounded-lg bg-white p-2 text-gray-800 hover:bg-experiment hover:text-white'>
      <div className='relative w-full overflow-hidden rounded-lg' style={{ aspectRatio: '16 / 9' }}>
        {isPlaying ? (
          <iframe
            src={`https://www.youtube.com/embed/${youtubeVideoId}?${params}&autoplay=1`}
            title={generateMatchTitle(video)}
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
            className='absolute inset-0 h-full w-full border-0'
          />
        ) : (
          <button
            type='button'
            className='group absolute inset-0 h-full w-full cursor-pointer border-0 bg-transparent p-0'
            onClick={() => setIsPlaying(true)}
            aria-label={`Play ${generateMatchTitle(video)}`}
          >
            <img
              src={thumbnailUrl}
              alt={generateMatchTitle(video)}
              loading='lazy'
              className='h-full w-full object-cover'
            />
            {/* Play button overlay */}
            <div className='absolute inset-0 flex items-center justify-center'>
              <div className='flex h-12 w-[68px] items-center justify-center rounded-lg bg-[#212121]/80 transition-colors group-hover:bg-[#f00]'>
                <svg viewBox='0 0 24 24' className='h-6 w-6 fill-white'>
                  <path d='M8 5v14l11-7z' />
                </svg>
              </div>
            </div>
          </button>
        )}
      </div>
      <p className='mt-1 line-clamp-1' title={generateMatchTitle(video)}>
        {generateMatchTitle(video)}
      </p>
    </div>
  );
};
